import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
	static targets = ["modal"]

	openModal() {
		this.modalTarget.setAttribute("style", "display: block;")
	}

	closeModal() {
		this.modalTarget.setAttribute("style", "display: none;")
	}
}
